import * as React from "react";
import { DialogueContext } from "../../../Components/ActionsMenu";
import {
  TextInput,
  AutocompleteInput,
  useGetList,
  useRecordContext,
  useResourceContext,
  required,
} from "react-admin";
import { EditForm } from "../../../Layout/EditForm";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";

export const EditGameForm = ({ handleClose, id, resource }) => {
  const { data: buildingData, isPending: isBuildingPending } = useGetList(
    "VegasBuilding",
    {
      pagination: { page: 1, perPage: 10 },
      sort: { field: "createdAt", order: "ASC" },
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const buildingChoices = isBuildingPending
    ? [{ id: "Null", name: "Loading..." }]
    : buildingData.map((b) => ({
        id: b.id,
        name: b.name ?? b.get?.("name") ?? "Unnamed Building",
      }));

  const gameTypeChoices = [
    { id: "VE", name: "VE" },
    { id: "TD", name: "TD" },
  ];

  return (
    <EditForm
      title="Edit Game"
      handleClose={handleClose}
      id={id}
      resource={resource}
    >
      <Grid item xs={12}>
        <TextInput
          id="name"
          name="name"
          label="Name"
          fullWidth
          validate={[required()]}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <TextInput
          id="gameSequence"
          name="gameSequence"
          label="Game Sequence"
          fullWidth
          validate={[required()]}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, "");
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <AutocompleteInput
          source="building"
          label="Game Building"
          choices={buildingChoices}
          fullWidth
          optionText="name"
          optionValue="id"
          validate={[required()]}
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          id="category"
          name="category"
          label="Category"
          fullWidth
          validate={[required()]}
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          id="description"
          name="description"
          label="Description"
          fullWidth
        />
      </Grid>
    </EditForm>
  );
};

export const EditGameFormDialog = ({ openDialog, handleDialogClose }) => {
  const { handleMenuClose } = React.useContext(DialogueContext);
  const handleClose = () => {
    handleDialogClose();
    handleMenuClose();
  };
  const record = useRecordContext();
  const resource = useResourceContext();

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={openDialog}
      onClose={handleClose}
      onKeyDown={(evt) => evt.stopPropagation()}
    >
      <EditGameForm
        handleClose={handleClose}
        id={record.id}
        resource={resource}
      />
    </Dialog>
  );
};
